import type React from 'react';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import type { BlockRendererProps } from '../../../context/RegistryProvider/types';

export const withPortalRenderer = (WrappedComponent: React.ComponentType<BlockRendererProps>) => {
  // only block portals are only used in the delta matrix, so we can skip this HOC in other environments
  if (!process.env.DELTA_MATRIX) {
    return WrappedComponent;
  }

  function withPortalRendererWrapper(props: BlockRendererProps) {
    const { block } = props;
    const blockId = block.id;
    // @ts-expect-error - portalEl is only used in the delta matrix
    const portalEl = block.portalEl;

    // If the block is not a portal, we can skip this HOC
    if (!portalEl) {
      return <WrappedComponent {...props} />;
    }

    return createPortal(<WrappedComponent {...props} />, portalEl, blockId);
  }

  return memo(withPortalRendererWrapper);
};
